(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsp-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSlider = (section) => {
      if (!section || section.dataset.rspSliderReady === 'true') return;

      const scroller = section.querySelector('.rsp-floating-products__scroller');
      const previousButton = section.querySelector('.rsp-floating-products__arrow--previous');
      const nextButton = section.querySelector('.rsp-floating-products__arrow--next');

      if (!scroller || !previousButton || !nextButton) return;

      section.dataset.rspSliderReady = 'true';

      const updateButtons = () => {
        const maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        previousButton.disabled = scroller.scrollLeft <= 2;
        nextButton.disabled = maximumScroll <= 2 || scroller.scrollLeft >= maximumScroll - 2;
      };

      const scrollProducts = (direction) => {
        const firstItem = scroller.querySelector('.rsp-floating-products__item');
        const gap = parseFloat(window.getComputedStyle(scroller).columnGap) || 0;
        const itemWidth = firstItem
          ? firstItem.getBoundingClientRect().width + gap
          : scroller.clientWidth;
        const visibleItems = firstItem
          ? Math.max(1, Math.floor(scroller.clientWidth / itemWidth))
          : 1;

        scroller.scrollBy({
          left: direction * itemWidth * visibleItems,
          behavior: 'smooth'
        });
      };

      previousButton.addEventListener('click', () => scrollProducts(-1));
      nextButton.addEventListener('click', () => scrollProducts(1));
      scroller.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('.rsp-floating-products').forEach(initializeSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsp-floating-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSlider = (section) => {
      if (!section || section.dataset.rspSliderReady === 'true') return;
      const scroller = section.querySelector('.rsp-floating-products__scroller');
      const previousButton = section.querySelector('.rsp-floating-products__arrow--previous');
      const nextButton = section.querySelector('.rsp-floating-products__arrow--next');
      if (!scroller || !previousButton || !nextButton) return;
      section.dataset.rspSliderReady = 'true';
      const updateButtons = () => {
        const maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        previousButton.disabled = scroller.scrollLeft <= 2;
        nextButton.disabled = maximumScroll <= 2 || scroller.scrollLeft >= maximumScroll - 2;
      };
      const scrollProducts = (direction) => {
        const firstItem = scroller.querySelector('.rsp-floating-products__item');
        const gap = parseFloat(window.getComputedStyle(scroller).columnGap) || 0;
        const itemWidth = firstItem ? firstItem.getBoundingClientRect().width + gap : scroller.clientWidth;
        const visibleItems = firstItem ? Math.max(1, Math.floor(scroller.clientWidth / itemWidth)) : 1;
        scroller.scrollBy({ left: direction * itemWidth * visibleItems, behavior: 'smooth' });
      };
      previousButton.addEventListener('click', () => scrollProducts(-1));
      nextButton.addEventListener('click', () => scrollProducts(1));
      scroller.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    };
    const initializeAll = (root = document) => { root.querySelectorAll('.rsp-floating-products').forEach(initializeSlider); };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => initializeAll()); } else { initializeAll(); }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
